function projectFilterProcess() { 
    
    const pageNumberInput = projectFilter.querySelector(".js-page-number"),
        ajaxLoading = document.querySelector(".js-ajax-loading"),
        ajaxPaginating = document.querySelector(".js-ajax-paginating"),
        projectsTarget = document.querySelector(".js-projects-target"),
        //projectsFilterAll = document.querySelector(".js-filter-all"),
        projectFilterToggle = document.querySelector(".js-filter-toggle"),
        // noMoreProjects = document.querySelector(".js-projects-no-more"),
        filterLabel = document.querySelectorAll(".js-filter-label"),
        projectFilterContainer = document.querySelector(".js-filter-container");

    var $projectFilter = $('#project-filter');

    let pageNumber = 1,
        ajaxType = "full",
        urlString = "",
        filterArray,
        filterRadioActive = projectFilter.querySelector(
            'input[name="project-type"]:checked'
        ),
        isFilterOpen = false;

        pageNumberInput.value = 1;

    submitFilter(ajaxType);

    projectFilter.addEventListener("change", () => {

        filterRadioActive = projectFilter.querySelector(
            'input[name="project-type"]:checked'
        );
        pageNumberInput.value = 1;

        submitFilter("full");
    });

    // projectsFilterAll.addEventListener("click", (e) => {
    //     e.preventDefault();

    //     projectsFilterAll.classList.add("is-active");
        
    //     filterRadioActive.forEach((checkbox) => {
    //         checkbox.checked = false;
    //     });

    //     filterRadioActive = projectFilter.querySelectorAll(
    //         'input[name="project-type"]:checked'
    //     );

    //     pageNumberInput.value = 1;

    //     submitFilter("full");
    // });

    projectFilterToggle.addEventListener('click', (e) => {
        e.preventDefault();

        isFilterOpen = !isFilterOpen;

        if (isFilterOpen) {
            projectFilterContainer.classList.add('is-active');
            projectFilterToggle.innerHTML = 'Close';

            filterLabel.forEach((btn) => {
                btn.addEventListener('click', () => {
                    projectFilterContainer.classList.remove('is-active');
                    projectFilterToggle.innerHTML = 'Filter';
                    isFilterOpen = false;
                });
            });

            // projectsFilterAll.addEventListener("click", () => {
            //     projectFilterContainer.classList.remove('is-active');
            //     projectFilterToggle.innerHTML = 'Filter';
            //     isFilterOpen = false;
            // });
            
        } else {
            projectFilterContainer.classList.remove('is-active');
            projectFilterToggle.innerHTML = 'Filter';
        }
    });

    //infinite load
    function infinitePagination() {
        let st = window.pageYOffset;

        let ajaxPaginationTrigger = document.body.scrollHeight - window.innerHeight - 200;

        window.addEventListener("resize", () => {
            ajaxPaginationTrigger = document.body.scrollHeight - window.innerHeight - 200;
        });

        if (st >= ajaxPaginationTrigger && !body.classList.contains('working')) {

            $('#resultsInfo').remove();

            filterRadioActive = projectFilter.querySelector(
                'input[name="project-type"]:checked'
            );
    
            pageNumber = projectsTarget.dataset.nextpage; 
            
            pageNumberInput.value = pageNumber;
    
            submitFilter("paginate");
        }

    }


    function submitFilter(ajaxType) {
        $body.addClass("working");

        // noMoreProjects.classList.remove('is-active');

        if (ajaxType == "full") {
            gsap.to(projectsTarget, 0.3, { autoAlpha: 0, ease: Power1.easeInOut });
            gsap.to(ajaxLoading, 0.3, { autoAlpha: 1, ease: Power1.easeInOut });
        } else {
            gsap.to(ajaxPaginating, 0.3, { autoAlpha: 1, ease: Power1.easeInOut });
        }

        pageNumber = pageNumberInput.value;

        urlString = "?project-type=" + filterRadioActive.value + "&pg=" + pageNumber;

        // filterRadioActive.forEach((checkbox) => {
        //     if (filterCount === 0) {
        //         urlString += "?project-type=";
        //     }
        //     if (filterCount > 0) {
        //         urlString += "-";
        //     }
        //     urlString += checkbox.value;
        //     filterCount++;
        // });

        // if (urlString !== "") {
        //     urlString += "&pg=" + pageNumber;
        // } else {
        //     urlString = "?pg=" + pageNumber;
        // }

        window.history.pushState("", "", urlString);

        filterArray = $projectFilter.serialize(); 

        $.ajax({
            url:$projectFilter.attr('action'),
            data: {term: filterArray },
            type:$projectFilter.attr('method'), 

            success:function(data){	
                                    
                if (ajaxType == 'full') {					
                    gsap.to(ajaxLoading, 0.3, { autoAlpha: 0, ease: Power1.easeInOut });
                    gsap.to(projectsTarget, 0.3, { autoAlpha: 1, ease: Power1.easeInOut });
                    projectsTarget.innerHTML = data;
                } else {
                    window.removeEventListener("scroll", infinitePagination);
                    gsap.to(ajaxPaginating, 0.3, { autoAlpha: 0, ease: Power1.easeInOut });
                    projectsTarget.innerHTML =  projectsTarget.innerHTML + data;
                }

                let resultsInfo = document.querySelector(".js-results-info");
                let newPage = resultsInfo.dataset.page;
                let nextPage = parseInt(newPage) + 1;
                let totalPages = resultsInfo.dataset.pages;

                pageNumberInput.value = newPage;  

                if (nextPage <= totalPages) {
                    projectsTarget.dataset.nextpage = nextPage;
                    window.addEventListener("scroll", infinitePagination);
                } else {	                
                    window.removeEventListener("scroll", infinitePagination);
                    // noMoreProjects.classList.add('is-active');
                }               
                
                lazyLoad(threshold, scrollElement);	
                $body.rhLoadIn();

                setTimeout(function(){ 
                    $body.removeClass('working');
                }, 100);				
                
            }
        });
        
    }

}
